import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef
} from '@angular/core';
import { ButtonSize, ButtonStyle, ButtonType } from '../../enums/button.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  type: InputSignal<ButtonType> = input<ButtonType>('button');
  style: InputSignal<ButtonStyle> = input<ButtonStyle>(ButtonStyle.Primary);
  size: InputSignal<ButtonSize> = input<ButtonSize>(ButtonSize.Medium);
  outline: InputSignal<boolean> = input<boolean>(false);

  // State
  disabled: InputSignal<boolean> = input<boolean>(false);
  loading: InputSignal<boolean> = input<boolean>(false);
  buttonClick: OutputEmitterRef<Event> = output<Event>();
}
